import { FETCH, SET, FETCH_SUCCESS, FETCH_FAILURE, SET_USER,SET_ALERT } from './actionTypes';

export function setAuthenticated(payload: any) {
  return {
    type: 'SET_IS_AUTHENTICATED',
    payload
  }
}

export function set(payload: any) {
  return {
    type: SET,
    payload
  }
}
export function setAlert(payload: any) {
  return {
    type: SET_ALERT,
    payload
  }
}


export function setUser(payload: any) {
  return {
    type: SET_USER,
    payload
  }
}

export function fetch(payload: any) {
  return {
    type: FETCH,
    payload
  }
}

export function fetchSuccess(payload?: any) {
  return {
    type: FETCH_SUCCESS,
    payload
  }
}

export function fetchFail(payload: any) {
  return {
    type: FETCH_FAILURE,
    payload
  }
}
